import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import { useSize } from 'ahooks';

// 电池
const battery = (
    <svg xmlns="http://www.w3.org/2000/svg" width="136" height="71" viewBox="0 0 136 71" fill="none">
        <g clipPath="url(#clip0_6389_12685)">
            <path
                d="M68.4242 70.1364L76.1327 60.579H103.594V10.4022H75.0989V0.844727H106.106C108.104 0.84694 110.02 1.60286 111.433 2.94666C112.846 4.29047 113.64 6.11241 113.643 8.01284V62.9683C113.64 64.8688 112.846 66.6907 111.433 68.0346C110.02 69.3783 108.104 70.1342 106.106 70.1364H68.4242ZM51.1797 40.2025H32.5975L63.7479 1.34052V30.9328H82.8049L51.1797 70.1364V40.2025ZM39.7243 70.1364H8.13307C6.13501 70.1342 4.21945 69.3783 2.8066 68.0346C1.39376 66.6907 0.599006 64.8688 0.59668 62.9683V8.01284C0.599006 6.11241 1.39376 4.29047 2.8066 2.94666C4.21945 1.60286 6.13501 0.84694 8.13307 0.844727H46.8676L39.2056 10.4022H10.6452V60.579H39.7256V70.1364H39.7243ZM122.436 49.8269C122.102 49.8269 121.782 49.701 121.547 49.4769C121.311 49.2529 121.179 48.949 121.179 48.6321V22.3491C121.179 22.0322 121.311 21.7283 121.547 21.5043C121.782 21.2803 122.102 21.1544 122.436 21.1544H133.739C134.073 21.1544 134.393 21.2803 134.628 21.5043C134.863 21.7283 134.996 22.0322 134.996 22.3491V48.6321C134.996 48.949 134.863 49.2529 134.628 49.4769C134.393 49.701 134.073 49.8269 133.739 49.8269H122.436Z"
                fill="url(#paint0_linear_6389_12685)"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_6389_12685" x1="0.596699" y1="10.0837" x2="86.6151" y2="-31.0462" gradientUnits="userSpaceOnUse">
                <stop stopColor="#3F68E0" />
                <stop offset="1" stopColor="#7D9DFC" />
            </linearGradient>
            <clipPath id="clip0_6389_12685">
                <rect width="135.333" height="70" fill="white" transform="translate(0 0.844727)" />
            </clipPath>
        </defs>
    </svg>
);

const svg1 = (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_6390_12986)">
            <path
                d="M24.7608 8.08437C22.8355 6.76914 20.5076 6 18 6C11.3726 6 6 11.3726 6 18C6 18.3677 6.01654 18.7316 6.04892 19.0909M10.3796 27.2703C12.4521 28.9759 15.1064 30 18 30C24.6274 30 30 24.6274 30 18C30 17.3469 29.9478 16.7059 29.8474 16.0811"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path d="M24.8971 4.5L27.1471 8.39711L23.25 10.6471" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.41505 30.4118L8.25037 26.0651L12.597 24.9004" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.75 12L15 18H20.25L16.5 24" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <filter
                id="filter0_b_6390_12986"
                x="-1.68421"
                y="-1.68421"
                width="39.3684"
                height="39.3684"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.842105" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6390_12986" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_6390_12986" result="shape" />
            </filter>
        </defs>
    </svg>
);

const svg2 = (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_6390_12991)">
            <circle cx="18.5267" cy="18.263" r="14.3333" stroke="black" strokeWidth="2" />
            <path d="M10.5273 14.2637V22.597" stroke="black" strokeWidth="1.86667" strokeLinecap="round" />
            <path d="M14.5273 11.9297V24.5964" stroke="black" strokeWidth="1.86667" strokeLinecap="round" />
            <path d="M18.5273 9.59668V26.93" stroke="black" strokeWidth="1.86667" strokeLinecap="round" />
            <path d="M22.5273 12.9297V23.5964" stroke="black" strokeWidth="1.86667" strokeLinecap="round" />
            <path d="M26.5273 16.2637V20.2637" stroke="black" strokeWidth="1.86667" strokeLinecap="round" />
        </g>
        <defs>
            <filter
                id="filter0_b_6390_12991"
                x="-1.99897"
                y="-2.26362"
                width="41.0526"
                height="41.0526"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.26316" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6390_12991" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_6390_12991" result="shape" />
            </filter>
        </defs>
    </svg>
);

export default function TheComp() {
    const { t } = useLang('theProduct.Highlights');

    const items1 = [
        { title: t('item1_title'), desc: t('item1_desc'), icon: battery },
        { title: t('item2_title'), desc: t('item2_desc'), pc: 'https://websiteoss.ecoflow.com/upload/image/1737688877731/Highlights-2.jpg' },
        { title: t('item3_title'), desc: t('item3_desc'), pc: 'https://websiteoss.ecoflow.com/upload/image/1737688877900/Highlights-3.jpg' },
        { title: t('item4_title'), desc: t('item4_desc'), pc: 'https://websiteoss.ecoflow.com/upload/image/1737688878092/Highlights-4.jpg' },
    ];
    const items2 = [
        { title: t('item5_title'), desc: t('item5_desc'), icon: svg1 },
        { title: t('item6_title'), desc: t('item6_desc'), icon: svg2 },
        {
            title: t('item7_title'),
            desc: t('item7_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737688878273/Highlights-7.jpg',
            tip: '20ms',
        },
        { title: t('item8_title'), desc: t('item8_desc'), pc: 'https://websiteoss.ecoflow.com/upload/image/1737688878447/Highlights-8.jpg' },
    ];

    const h5item1 = [
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            h5: 'https://websiteoss.ecoflow.com/upload/image/1738722070647/d.jpg',
        },
        {
            title: t('item7_title'),
            desc: t('item7_desc'),
            h5: 'https://websiteoss.ecoflow.com/upload/image/1738722290558/g.jpg',
            tip: '20ms',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            h5: 'https://websiteoss.ecoflow.com/upload/image/1738722290344/b.jpg',
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            h5: 'https://websiteoss.ecoflow.com/upload/image/1738722471623/c.jpg',
        },
    ];
    const h5item2 = [
        [
            { title: t('item6_title'), desc: t('item6_desc'), icon: svg2 },
            {
                title: t('item8_title'),
                desc: t('item8_desc_h5'),
                h5: 'https://websiteoss.ecoflow.com/upload/image/1738722659283/h.jpg',
            },
        ],
        [
            { title: t('item1_title'), desc: t('item1_desc'), icon: battery },
            { title: t('item5_title'), desc: t('item5_desc'), icon: svg1 },
        ],
    ];

    const [isH5, setIsH5] = useState(false);
    const size = useSize(() => (document ? document.body : null));
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(size?.width ? size.width < 768 : window.innerWidth < 768);
        }
    }, [size]);
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            {isH5 ? (
                <div className="highlights-h5">
                    <div className="highlights-h5-top">
                        {h5item1.map((item, idx) => (
                            <div className="highlights-item" key={idx}>
                                <div className="highlights-item-info">
                                    <div className="highlights-item-title">{item.title}</div>
                                    {item.desc && <div className="highlights-item-desc">{item.desc}</div>}
                                </div>
                                {item.h5 && <EfImg pc={item.h5} />}
                            </div>
                        ))}
                    </div>
                    <div className="highlights-h5-bottom">
                        {h5item2.map((arr, idx) => (
                            <div className="highlights-h5-bottom-item" key={idx}>
                                {arr.map((item, idx2) => (
                                    <div className="highlights-item" key={`${idx}-${idx2}`}>
                                        <div className="highlights-item-info">
                                            <div className="highlights-item-title">{item.title}</div>
                                            {item.desc && <div className="highlights-item-desc">{item.desc}</div>}
                                        </div>
                                        {item.icon}
                                        {item.h5 && <EfImg pc={item.h5} />}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="highlights">
                    <div className="highlights-left">
                        {items1.map((item, idx) => (
                            <div className="highlights-item" key={idx}>
                                <div className="highlights-item-info">
                                    <div className="highlights-item-title">{item.title}</div>
                                    {item.desc && <div className="highlights-item-desc">{item.desc}</div>}
                                </div>
                                {item.icon}
                                {item.pc && <EfImg pc={item.pc} />}
                            </div>
                        ))}
                    </div>
                    <div className="highlights-right">
                        {items2.map((item, idx) => (
                            <div className="highlights-item" key={idx}>
                                {item.icon}
                                <div className="highlights-item-info">
                                    {item.tip && <div className="highlights-item-tip">{item.tip}</div>}
                                    <div className="highlights-item-title">{item.title}</div>
                                    {item.desc && <div className="highlights-item-desc">{item.desc}</div>}
                                </div>
                                {item.pc && <EfImg pc={item.pc} />}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <EfSpec />
        </div>
    );
}
